export const fullTimeJobs = [
  {
    title: "Product & Data at Climate Action Data Trust",
    description:
      "Currently at CAD Trust, I lead the technical onboarding of registry ETL infrastructure while architecting agentic AI and automation systems. My work focuses on engineering a unified, harmonized data layer for global carbon markets, leveraging Python, TypeScript, and the Chia Blockchain to ensure data integrity at scale. From cloud architecture to MCP-driven agents, I build systems for scaling the carbon market data ecosystem",
    contribution:
      "Built agentic AI and automation systems including n8n data mapping workflows, a RAG pipeline, and a proof-of-concept MCP server connected to openClaw and a Claude-powered chatbot for carbon market data users. Containerized services with Docker and led ETL infrastructure for registry onboarding across global carbon markets. Tech stack: Python, TypeScript, Chia Blockchain, n8n, Claude API, Docker.",
  },
  {
    title: "AI Software Developer & Research Officer at SUTD",
    description:
      "Developed a VS Code extension integrating LLMs (ChatGPT, Claude) as a code assistant for novice programmers. Focused on promoting debugging skills over vibe coding, enhanced with Retrieval Augmented Generation (RAG) for better code solutions. Conducted user testing with > 60 first-year programming students. Co-authored 3 research papers.",
    contribution:
      "Tech Stack: Express, TypeScript, MongoDB, LangChain, Svelte. Deployment: Heroku backend, VS Code Marketplace",
  },
];

export const internships = [
  {
    title: "Data Engineer / Technical Product Manager at Climate Action Data Trust",
    description:
      "CADTrust is a decentralised metadata platform that links carbon credit data from major registries, founded by World Bank, International Emission Trading Agencies (IETA), and Government of Singapore.",
    contribution:
      "I played a pivotal role in ETL processing and GCP cloud deployment for registry onboarding, overseeing stakeholder management and technical integration through proactive UAT testing. Additionally, I processed 40,000 CDM UNFCCC Registry carbon credits, integrated with the Chia blockchain data layer, and automated the ETL process with Python and Pandas dataframe.",
  },
  {
    title: "Software Engineer at Mediacorp",
    description:
      "Mediacorp is a nationwide and worldwide broadcasting company in Singapore. I served 16 weeks of internship at Digital and Web Development Team, specifically meCONNECT SSO Platform.",
    contribution:
      "Skills learned: Web API Infrastructure with .NET Core/C#, CI/CD with Jenkins, Unit Testing with PHPUnit, React.js, Tailwind CSS, Microsoft Azure DevOps, and Braze Platform. Contributed to the meCONNECT Platform during the World Cup 2022, which successfully handled traffic from 600,000 users.",
  },
];

export const softwareProjects = [
  {
    title: "ResQ Personal Alarm Device Kit",
    description:
      "Final Year Group Project in collaboration with Gebirah, a global humanitarian and social initiative.",
    contribution:
      "We developed an IoT-based personal alarm device for elderlies in Singapore to instantly alert nearby individuals and emergency contacts while facing emergency situations. I designed the SQL databases, configured AWS services (EC2, MySQL), and developed secure RESTful APIs using Node.js, Express.js for a smartphone-connected IoT alarm device.",
  },
  {
    title: "Ascenda Loyalty Program Marketplace",
    description:
      "Ascenda Loyalty operates an API based Loyalty Points Marketplace which facilitates easy and seamless loyalty currency transfers between multiple loyalty programs.",
    contribution:
      "Built the backend code infrastructure with Node.js, Express.js, and MongoDB database. Implemented CRUD endpoints for real time transaction features and automated uploading/downloading process to/from SFTP Server, as well as unit testing with Jest Supertest Library.",
  },
  {
    title: "Smart Canteen @SUTD (Android App)",
    description:
      "An easy-to-use mobile application which allows people to check what dishes are available today and whether the stalls are still open.",
    contribution:
      "Contributed in automating image uploading and storing system into Firebase Storage which also returned the cloud URL link that is passed to the Firebase Realtime Database. Implemented the database management class where the added menu details and images can be automatically displayed inside the Frontend RecyclerView User Interface.",
  },
];

export const blockchainProjects = [
  {
    title: "Heartledger DApp",
    description:
      "Developed a charity application using Solidity, executed smart contract deployment locally with Ganache EVM, and launched on Mumbai testnet. Utilised Truffle Library and Jest Testing.",
    contribution: "",
  },
];

export const dataProjects = [
  {
    title: "Temasek Generative AI Hackathon",
    description:
      "Collaborated with the business team from Temasek, a global investment company in Singapore.",
    contribution:
      "Utilized Python and OpenAI's GPT library to create an information retrieval pipeline tailored for event planning and personalized letter notes. Extracted text from PDFs and Word files, generating FAISS vector embeddings for large PDFs to facilitate indexing. Developed a scalable indexing system ranking the top 5 documents based on user queries.",
  },
  {
    title: "Deep Learning Cancer Cell Classification",
    description:
      "Implemented transfer learning and finetuning training of Several Models such as Regnet, ResNet, VGG.",
    contribution:
      "Won Best Project based on Kaggle Competition Rank at Uppsala University (my exchange university).",
  },
  {
    title: "Deep Learning MNIST and CNN Segmentation Project",
    description:
      "Performed classification of the MNIST dataset with PyTorch Deep Learning Library and reached 98 percent accuracy.",
    contribution:
      "Segmented Warwick Biomedical Dataset to detect gland in the image by implementing fully convolutional network with 0.9 Macro F1 Score.",
  },
  {
    title: "Machine Learning: Hate Speech Classification",
    description:
      "Final Project in Machine Learning Course to create the best model and compete with other groups.",
    contribution:
      "From the provided cleaned data with TF-IDF implementation, explored SVM, Random Forest, ExtraTree, XGBoost, and Adaboost Algorithms and eventually used SVM with self-customised kernel function.",
  },
  {
    title: "Machine Learning: Covid-19 Death Prediction",
    description: "Final Project in Data Driven World Course.",
    contribution:
      "Cleaned the World Covid-19 Data sourced from Kaggle with Pandas and Numpy Python Library and built a Linear regression model with 90 percent accuracy against the number of total cases, total tests, vaccination rates, population.",
  },
];

export const competitions = [
  {
    title: "5th Place — PyCon SG 2026 Hackathon (Job & Skills Track)",
    description:
      "Career Radar is a platform to keep you career-ready whether you're not actively job hunting, suddenly get laid off, or want to change jobs next year. Uses Singapore's SkillsFuture data alongside your CV, saved job alerts, and work logs to turn scattered signals into one explainable skills-gap view.",
    contribution:
      "Won 5th place and $1,000 in OpenAI credits. Tech stack: FastAPI, Claude, Supabase, Gmail OAuth, Apify LinkedIn and Indeed Job Search, SkillsFuture API.",
    link: "https://career-skills-radar.vercel.app/",
  },
  {
    title: "3rd Place — EasyA x VeChain x BCG Hackathon 2024",
    description:
      "MoveLiteToEarn is a fitness move-to-earn application built on the VeChain blockchain, rewarding users with tokens for physical activity.",
    contribution:
      "Won 3rd place. Tech stack: Solidity, VeChain.",
    link: "https://github.com/erickch123/MoveLiteToEarn",
  },
  {
    title: "Third Place in DBS Bank Design and AI Challenge",
    description:
      "Competition held by SUTD and DBS Bank to predict a promising credit card.",
    contribution:
      "Proposed a credit card to target young working adults aged 25-33 which has the highest tendency to acquire new credit cards based on several Machine Learning Training Models using Scikit Library.",
  },
  {
    title: "PSA Hackathon CodeSprint 2022",
    description:
      "Proposed a solution to develop a means to track and ensure port users travel only to designated locations and leave the port once their jobs have been completed.",
    contribution:
      "Built a website with MERN (MongoDB, Express, Node, React) stack and Twilio that consist of security dashboard and internal form submission integrated with WhatsApp Messaging.",
  },
];

export const outsideProjects = [
  {
    title: "PPIS Tech Team",
    description:
      "Tech Team subdivision in Indonesia Community in Singapore, focusing in Backend.",
    contribution:
      "Learned about Wix API and Database and implemented features to automate member application processes and removal of expired members. Also contributed to Frontend features of a new membership info retrieval website with React.js and Tailwind.",
  },
  {
    title: "Swapswipe",
    description:
      "Swapswipe is a sustainable platform to swap or buy pre-loved books. Joined the team for Youth Action Plan Competition by National Youth Corps Singapore and won SGD 27,000 Grant in the category of Environment & Sustainability.",
    contribution:
      "Revamped the landing pages by splitting one long page into several menus, modifying the user interface and features pages under PHP/Laravel Web framework, jQuery, Bootstrap, and Docker Container.",
  },
];

export const personalProjects = [
  {
    title: "CreditMiles Tracker",
    description:
      "A personal finance dashboard for managing 15+ Singapore credit cards — tracking monthly spend per card, rewards balances (KrisFlyer, Avios, bank points) with expiry countdowns, statement closing and payment due dates on a billing calendar, and a miles calculator that shows the optimal bank-to-airline transfer for any given points balance.",
    contribution:
      "Transactions can be added manually or synced from Google Sheets, with email and push notification reminders for upcoming payments and annual fees. Currently in development. Tech stack: Next.js, TypeScript, Supabase (PostgreSQL + Auth + Edge Functions), Tailwind CSS, shadcn/ui, Recharts, Google Sheets API, Resend, Vercel.",
    link: "https://credit-miles-tracker.vercel.app/",
  },
  {
    title: "TrackHub: My Life in Data",
    description:
      "A personal analytics dashboard I built to track my time from my senior year of college into adult working life. What started as a messy Python notebook is now a clean, interactive web app where I can visualize my productivity, sleep habits, and how much time I'm spending on side projects.",
    contribution: "Tech stack: Next.js, React, Tailwind CSS",
    link: "https://trackhub-eta.vercel.app/",
  },
  {
    title: "Intentional Instagram App",
    description:
      "Built this web application to address my need for limiting Instagram usage by narrowing down the topics I see on my feed. The app categorises followings based on selected topics and is designed to help users focus on specific content.",
    contribution:
      "Built using React, Express, Tailwind CSS, and MongoDB. External services: RapidAPI, Facebook and Google OAuth.",
    link: "https://intentionalgram.vercel.app/",
  },
  {
    title: "Landing Page: Indocoffee Carbon Credit Projects",
    description:
      "Passion project developing carbon credit initiatives for Indonesian coffee farms.",
    contribution: "Tech stack: Next.js, Vercel",
    link: "https://indocoffee-carbon-credit.vercel.app/",
  },
  {
    title: "This Website",
    description:
      "This website is for me to showcase what I've done, not only in software engineering projects but my other hobbies as well.",
    contribution: "Built with React.js Framework and Tailwind CSS.",
  },
];
